module.exports = __webpack_public_path__ + "static/media/landing_banner_zh.40ba7537.png";